module.exports = __webpack_public_path__ + "img/sasebo_okura.5b3a29c2.jpg";